import { BillingBonusModel } from '@/billing/entities/BillingBonus';
import { BillingDashboardModel } from '@/billing/entities/BillingDashboard';
import { BillingTransactionModel } from '@/billing/entities/BillingTransaction';
import { SerializedQuery } from '@/billing/serializers/TransactionsQuerySerializer';
import CutwiseAPIClient, { METHOD_GET, METHOD_POST } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';

import { BillingExpensesModel } from '../entities/BillingExpenses';
import { DashboardFilter } from '../stores/DashboardStore.types';

export const PATH_BILLING_ACCOUNT_EXPENSES = 'api/billing/account/expenses';
export const PATH_BILLING_ACCOUNT_DASHBOARD = 'api/billing/account/dashboard';
export const PATH_BILLING_TRANSACTIONS = 'api/billing/transaction';
export const PATH_EXPORT_BILLING_TRANSACTIONS = 'api/billing/transaction/export';
const PATH_BILLING_PRODUCT_TRANSACTIONS = 'api/billing/transaction/product';

export const PATH_BILLING_PAYMENT = 'api/billing/payment/enroll';
export const PATH_BONUS = 'api/billing/bonus';

export default class BillingAPI {
  getAccountExpenses(filter: Partial<DashboardFilter>): Promise<QueryResult<BillingExpensesModel>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(PATH_BILLING_ACCOUNT_EXPENSES)
      .addQueryStringParam('b2b', filter.b2b)
      .addQueryStringParam('period', filter.period);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  getAccountDashboard(b2b?: string): Promise<QueryResult<BillingDashboardModel>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(PATH_BILLING_ACCOUNT_DASHBOARD)
      .addQueryStringParam('b2b', b2b);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  getBillingTransactions(filter: SerializedQuery, b2b?: string): Promise<QueryResult<BillingTransactionModel[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_BILLING_TRANSACTIONS);

    const { offset, limit, order, ...rest } = filter;

    qb.offset(offset);
    qb.limit(limit);
    qb.addQueryStringParam('b2b', b2b);
    qb.addQueryStringParam('order', order);
    qb.addQueryStringParam('filter', rest.filter);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  exportBillingTransactionsToCSV(filter: SerializedQuery): Promise<QueryResult<string>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_EXPORT_BILLING_TRANSACTIONS).asText();

    qb.addQueryStringParam('filter', {
      offset: filter.offset,
      limit: filter.limit,
      order: filter.order,
      ...filter.filter,
    });

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  getProductTransactions<T>(productId: number): Promise<QueryResult<T>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(`${PATH_BILLING_PRODUCT_TRANSACTIONS}/${productId}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  getPaymentEnroll(amount: string): Promise<QueryResult<{ redirect: string }>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_POST).path(PATH_BILLING_PAYMENT).body({ amount });

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  getBonuses(b2b?: string): Promise<QueryResult<BillingBonusModel[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(PATH_BONUS)
      .addQueryStringParam('b2b', b2b);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
